<template>
  <div
    class="d-flex justify-center space-between justify-space-evenly flex-wrap ga-7"
  >
    <AgentSalesDistributionAreas
      :isLoading="isLoading"
      v-for="(agentSale, index) in agentSales"
      :tableLineBackground="isOdd(index + 1) ? '#ffefdb' : 'transparent'"
      :key="agentSale"
      :distributionArea="agentSale"
    />
  </div>
</template>

<script>
import { isOdd } from "../../utilities";
import AgentSalesDistributionAreas from "../helpers/AgentSalesDistributionAreas.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    AgentSalesDistributionAreas,
  },
  data() {
    return {
      isLoading: false,
      agentSales: [],
    };
  },
  mounted() {
    this.getAgentSales();
  },
  computed: {
    scrollList() {
      return "scroll-list";
    },
    ...mapGetters({
      isDesktop: "isDesktop",
    }),
  },
  methods: {
    isOdd(number) {
      return isOdd(number);
    },
    async getAgentSales() {
      this.isLoading = true;
      try {
        this.agentSales = await this.$store.dispatch(
          "ControlPanel/getAgentsSales"
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.scroll-list {
  overflow-y: scroll;
  max-height: 62vh;
}
</style>
